document.addEventListener("DOMContentLoaded", function () {
  const shopAllSelector = document.getElementById(
    "gtudev-megamenu-for-shop-all"
  );
  const shopAllTitle = document.getElementById(
    "gtudev-megamenu-for-shop-all-title"
  );
  const newArrivalsTitle = document.getElementById(
    "gtudev-megamenu-for-new-arrivals-title"
  );
  const customWheelsTitle = document.getElementById(
    "gtudev-megamenu-for-custom-wheels"
  );
  const exploreForgeLineTitle = document.getElementById(
    "gtudev-megamenu-for-explore-forge-line-title"
  );
  const exploreForgeLineSelector = document.getElementById(
    "gtudev-megamenu-for-explore-forge-line"
  );
  const upArrow = document.getElementById("gtudev-megamenu-shop-all-up");
  const downArrow = document.getElementById("gtudev-megamenu-shop-all-down");
  const customWheelsUpArrow = document.getElementById(
    "gtudev-megamenu-custom-wheels-up"
  );
  const customWheelsDownArrow = document.getElementById(
    "gtudev-megamenu-custom-wheels-down"
  );
  const exploreForgeLineUpArrow = document.getElementById(
    "gtudev-megamenu-explore-up"
  );
  const exploreForgeLineDownArrow = document.getElementById(
    "gtudev-megamenu-explore-down"
  );

  // Search elements (declare early so handlers can reference safely)
  const searchBtn = document.getElementById('gtudev-search-btn');
  const searchPanel = document.getElementById('gtudev-search-panel');
  const searchInput = document.getElementById('gtudev-search-input');

  let isOpen = false;
  let isOpenCustomWheels = false;
  let isOpenExploreForgeLine = false;

  // Ensure default (closed) state shows the down arrows and hides the up arrows
  if (upArrow) upArrow.style.display = "none";
  if (downArrow) downArrow.style.display = "inline-block";
  if (customWheelsUpArrow) customWheelsUpArrow.style.display = "none";
  if (customWheelsDownArrow) customWheelsDownArrow.style.display = "inline-block";
  if (exploreForgeLineUpArrow) exploreForgeLineUpArrow.style.display = "none";
  if (exploreForgeLineDownArrow) exploreForgeLineDownArrow.style.display = "inline-block";

  shopAllTitle.addEventListener("click", function (e) {
    e.stopPropagation();
  // Close other menu
  customWheelsTitle.style.display = "none";
  exploreForgeLineSelector.style.display = "none";
  exploreForgeLineDownArrow.style.display = "none";
  isOpenCustomWheels = false;
  isOpenExploreForgeLine = false;
  // default closed state should show the down arrow and hide the up arrow
  customWheelsUpArrow.style.display = "none";
  customWheelsDownArrow.style.display = "inline-block";
  exploreForgeLineUpArrow.style.display = "none";
  exploreForgeLineDownArrow.style.display = "inline-block";

    if (isOpen) {
      shopAllSelector.style.display = "none";
      // when closed: show down arrow (default), hide up
      upArrow.style.display = "none";
      downArrow.style.display = "inline-block";
      isOpen = false;
    } else {
      shopAllSelector.style.display = "block";
      // when open: show up arrow, hide down
      upArrow.style.display = "inline-block";
      downArrow.style.display = "none";
      isOpen = true;
    }
  });

  newArrivalsTitle.addEventListener("click", function (e) {
    e.stopPropagation();

  // Close other menu
  shopAllSelector.style.display = "none";
  exploreForgeLineSelector.style.display = "none";
  isOpen = false;
  isOpenExploreForgeLine = false;
  customWheelsTitle.style.display = "none";
  // closed state: show down arrows
  upArrow.style.display = "none";
  downArrow.style.display = "inline-block";
  exploreForgeLineUpArrow.style.display = "none";
  exploreForgeLineDownArrow.style.display = "inline-block";

    if (isOpenCustomWheels) {
      customWheelsTitle.style.display = "none";
      // closed state: show down arrow
      customWheelsUpArrow.style.display = "none";
      customWheelsDownArrow.style.display = "inline-block";
      isOpenCustomWheels = false;
    } else {
      customWheelsTitle.style.display = "block";
      // open state: show up arrow
      customWheelsUpArrow.style.display = "inline-block";
      customWheelsDownArrow.style.display = "none";
      isOpenCustomWheels = true;
    }
  });
  exploreForgeLineTitle.addEventListener("click", function (e) {
    e.stopPropagation();
  // Close other menu
  shopAllSelector.style.display = "none";
  isOpen = false;
  customWheelsTitle.style.display = "none";
  isOpenCustomWheels = false;
  // closed state: show down arrow
  upArrow.style.display = "none";
  downArrow.style.display = "inline-block";
  customWheelsUpArrow.style.display = "none";
  customWheelsDownArrow.style.display = "inline-block";

    if (exploreForgeLineSelector.style.display === "block") {
      exploreForgeLineSelector.style.display = "none";
      // closed state: show down arrow
      exploreForgeLineUpArrow.style.display = "none";
      exploreForgeLineDownArrow.style.display = "inline-block";

      isOpenExploreForgeLine = false;
    } else {
      exploreForgeLineSelector.style.display = "block";
      // open state: show up arrow
      exploreForgeLineUpArrow.style.display = "inline-block";
      exploreForgeLineDownArrow.style.display = "none";
      isOpenExploreForgeLine = true;
    }
  });

  document.addEventListener("click", function (e) {
    // Close both if click outside
    shopAllSelector.style.display = "none";
    customWheelsTitle.style.display = "none";
    exploreForgeLineSelector.style.display = "none";

  // reset to closed state: show down arrows
  upArrow.style.display = "none";
  downArrow.style.display = "inline-block";

  customWheelsUpArrow.style.display = "none";
  customWheelsDownArrow.style.display = "inline-block";

  exploreForgeLineUpArrow.style.display = "none";
  exploreForgeLineDownArrow.style.display = "inline-block";

    isOpen = false;
    isOpenCustomWheels = false;
    isOpenExploreForgeLine = false;
    // Close search panel if open and click is outside it
    if (searchPanel && searchPanel.getAttribute('aria-hidden') === 'false') {
      if (!searchPanel.contains(e.target)) {
        searchPanel.setAttribute('aria-hidden','true');
      }
    }
  });

  // Prevent clicks inside search panel from bubbling to the document close handler
  if(searchPanel){
    searchPanel.addEventListener('click', function(e){
      e.stopPropagation();
    });
  }

  // Mobile menu logic
  let menuBtn = document.getElementById("gtudev-mobile-menu-btn");
  let menuOverlay = document.getElementById(
    "gtudev-mobile-menu-overlay-main-display"
  );
  let menuClose = document.getElementById("gtudev-mobile-menu-close");
  let shopAllBtn = document.getElementById(
    "gtudev-mobile-menu-shop-all-display"
  );

  let customWheelsBtn = document.getElementById('gtudev-mobile-menu-nav-custom-wheels-display');
  
  let firstOverlay = document.getElementById('gtudev-mobile-menu-overlay');
  let secondOverlay = document.getElementById(
    "gtudev-mobile-menu-overlay-second"
  );

   let backBtn = document.getElementById("gtudev-mobile-menu-nav-back-button");
   let thirdOverlay = document.getElementById("gtudev-mobile-menu-nav-shop-all-title-first");
   let thirdOverlayContent = document.getElementById("gtudev-mobile-menu-overlay-third");
   let thirdOverlayClose = document.getElementById("gtudev-mobile-menu-nav-back-button-third");
   let footerSecond = document.getElementById("gtudev-mobile-menu-footer-second");
   let footerFirst = document.getElementById("gtudev-mobile-menu-footer");

   let fourthOverlay = document.getElementById("gtudev-mobile-menu-overlay-four");
   let fourthOverlayClose = document.getElementById("gtudev-mobile-menu-nav-back-button-four");
   let footerThird = document.getElementById("gtudev-mobile-menu-footer-third");

  menuBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    firstOverlay.style.display = "flex";
    menuOverlay.style.display = "flex";
    secondOverlay.style.display = "none";
    thirdOverlayContent.style.display = "none";
      footerFirst.style.display = "block";
    footerSecond.style.display = "none";
    document.body.style.overflow = "hidden";
  });

  menuClose.addEventListener("click", function (e) {
    e.stopPropagation();
    menuOverlay.style.display = "none";
    fourthOverlay.style.display = "none";
    document.body.style.overflow = "";
  });

  shopAllBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    firstOverlay.style.display = "none";
    secondOverlay.style.display = "flex";
    document.body.style.overflow = "hidden";
  });

    customWheelsBtn.addEventListener("click", function (e) {
    e.stopPropagation();
   fourthOverlay.style.display = "block";
   firstOverlay.style.display = "none";
   footerThird.style.display = "block";
   footerFirst.style.display = "none";
  });
backBtn.addEventListener("click", function (e) {
    e.stopPropagation();
    firstOverlay.style.display = "flex";
    secondOverlay.style.display = "none";
    document.body.style.overflow = "hidden";  
});

thirdOverlay.addEventListener("click", function (e) {
     e.stopPropagation();
    secondOverlay.style.display = "none";
    thirdOverlayContent.style.display = "flex";
    footerFirst.style.display = "none";
    footerSecond.style.display = "block";
    document.body.style.overflow = "hidden";
});
fourthOverlayClose.addEventListener("click", function (e) {
  e.stopPropagation();
  fourthOverlay.style.display = "none";
  firstOverlay.style.display = "flex";
  footerFirst.style.display = "block";
  footerThird.style.display = "none";
  document.body.style.overflow = "hidden";
})

thirdOverlayClose.addEventListener("click", function (e) {
    e.stopPropagation();
    thirdOverlayContent.style.display = "none";
    secondOverlay.style.display = "flex";
    footerFirst.style.display = "block";
    footerSecond.style.display = "none";
    document.body.style.overflow = "hidden";
})

  // Search panel logic (open from right to left) — simplified non-modal behavior

  function openSearch(){
    if(!searchPanel) return;
    searchPanel.setAttribute('aria-hidden','false');
    // focus input after animation starts
    setTimeout(function(){ if(searchInput) searchInput.focus(); }, 220);
  }

  function closeSearch(){
    if(!searchPanel) return;
    searchPanel.setAttribute('aria-hidden','true');
    // return focus to button
    if(searchBtn) searchBtn.focus();
  }

  if(searchBtn){
    searchBtn.addEventListener('click', function(e){
      e.stopPropagation();
      // toggle
      if(searchPanel && searchPanel.getAttribute('aria-hidden') === 'false'){
        closeSearch();
      } else {
        openSearch();
      }
    });
  }

  document.addEventListener('keydown', function(e){
    if(e.key === 'Escape' || e.key === 'Esc'){
      if(searchPanel && searchPanel.getAttribute('aria-hidden') === 'false'){
        closeSearch();
      }
    }
  });

  // ── Predictive Search (autocomplete dropdown) ─────────────────────────
  var searchResultsBox = document.getElementById('gtudev-search-results');
  var searchDebounceTimer = null;

  if(searchInput && searchResultsBox){
    searchInput.addEventListener('input', function(){
      clearTimeout(searchDebounceTimer);
      var query = searchInput.value.trim();
      if(query.length < 2){
        searchResultsBox.style.display = 'none';
        searchResultsBox.innerHTML = '';
        return;
      }
      showSearchLoading();
      searchDebounceTimer = setTimeout(function(){
        fetchPredictiveResults(query);
      }, 300);
    });

    // Close dropdown when clicking outside
    document.addEventListener('click', function(e){
      if(!searchResultsBox.contains(e.target) && e.target !== searchInput){
        searchResultsBox.style.display = 'none';
      }
    });
  }

  function showSearchLoading(){
    searchResultsBox.innerHTML =
      '<div class="gtudev-search-loading">' +
        '<div class="gtudev-search-spinner"></div>' +
        '<span>Searching...</span>' +
      '</div>';
    searchResultsBox.style.display = 'block';
  }

  function fetchPredictiveResults(query){
    var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8&resources[options][unavailable_products]=last';
    fetch(url)
      .then(function(res){ return res.json(); })
      .then(function(data){
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderPredictiveResults(products, query);
      })
      .catch(function(){
        searchResultsBox.innerHTML = '<div class="gtudev-search-no-results">Something went wrong. Try again.</div>';
        searchResultsBox.style.display = 'block';
      });
  }

  function renderPredictiveResults(products, query){
    if(!products.length){
      searchResultsBox.innerHTML = '<div class="gtudev-search-no-results">No products found for "' + query.replace(/</g,'&lt;') + '"</div>';
      searchResultsBox.style.display = 'block';
      return;
    }
    var html = '';
    products.forEach(function(p){
      var img = p.image || p.featured_image;
      var imgUrl = img ? (typeof img === 'string' ? img : img.url) : '';
      if(imgUrl && imgUrl.startsWith('//')){
        imgUrl = 'https:' + imgUrl;
      }
      var price = p.price ? ('$' + parseFloat(p.price).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')) : '';
      var pType = p.product_type || '';
      html += '<a href="' + p.url + '" class="gtudev-search-result-item">';
      if(imgUrl){
        html += '<img src="' + imgUrl + '&width=100" alt="" loading="lazy">';
      }
      html += '<div class="gtudev-search-result-info">';
      html += '<p class="gtudev-search-result-title">' + p.title + '</p>';
      if(price){
        html += '<p class="gtudev-search-result-price">' + price + '</p>';
      }
      if(pType){
        html += '<p class="gtudev-search-result-type">' + pType + '</p>';
      }
      html += '</div></a>';
    });
    html += '<a href="/search?q=' + encodeURIComponent(query) + '&options%5Bprefix%5D=last" class="gtudev-search-view-all">View all results</a>';
    searchResultsBox.innerHTML = html;
    searchResultsBox.style.display = 'block';
  }

});
